<div class="ir-area ir-mask th-mask" *ngIf="inspection">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right">
        <div class="ir-btn th-btn-modal" (click)="cancel()">
          <i class="material-icons">close</i>
        </div>
      </div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'inspections.validation' | translate }} &laquo; {{ inspection.name }} &raquo;</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <div class="ir-mv2 ir-mh2" *ngFor="let p of validatedPlugins">
          <ir-plugin
            [plugin]="p.data"
            [inspection]="inspection"
            [messages]="p.messages"
            [showBreadcrumbs]="true"
            [showValidations]="true"
            [showContent]="false"
          ></ir-plugin>
        </div>
        <div class="ir-item-empty ir-mv8" *ngIf="validatedPlugins.length == 0">
          <p>
            <span>{{ 'validation.no-errored-plugins' | translate }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
